<template v-if="true">
        <div>

            <v-card
    max-width="1080"
    class="mx-auto"
  >
    <v-list-item>
        <v-btn
                  @click="backTodisciplinList"
                  class="mx-2"
                  fab
                  dark
                  color="primary"
                  v-on="on"
                >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>
      <v-list-item-content>
        <v-list-item-title class="headline">Lançamento de Notas - Cadeirantes</v-list-item-title>
        <v-list-item-subtitle>Turma:
          <v-chip
              v-if="true"
              class="ma-2"
              close
              color="orange"
              label
              outlined
              >
              {{this.$store.state.objcadeira.turma_descricao}}
          </v-chip>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
      <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

         </v-col>

         <template v-if="progresso">
               <div class="text-center">
                  <v-progress-circular
                    :size="50"
                    color="blue"
                    indeterminate
                  ></v-progress-circular>
               </div>
            </template>

  <!--==============================A DATA TABLE============================================-->
      <v-data-table
            :headers="headers"
            :items="this.listaInscritos"
          >
            <template v-slot:item.name="props">
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
              <v-edit-dialog
                :return-value.sync="props.item.name"
                @save="save"
                @cancel="cancel"
                @open="open"
                @close="close"
              > {{ props.item.name }}
                <template v-slot:input>
                  <v-text-field
                    v-model="valor"
                    :rules="ruleTextRequired"
                    label="Insira a nota"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </v-form>
            </template>
            <template v-slot:item.nota="props">
              <v-edit-dialog
                :return-value.sync="props.item.nota"
                large
                persistent
                @save="save(props.item.nota)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div>{{ props.item.nota }}</div>
                <template v-slot:input>
                  <div class="mt-4 title">Update Iron</div>
                </template>
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.nota"
                    :rules="ruleTextRequired"
                    label="Edit"
                    single-line
                    counter
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>

          <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
          </v-snackbar>
  <!--==================================FIM DA DATA TABLE===================================-->
  </v-card>

        </div>
</template>

<script>
import axios from '../../plugins/axios'
import { get } from 'local-storage'
const ls = require('local-storage')
export default {
  data () {
    return {
      snack: false,
      snackColor: '',
      snackText: '',
      pagination: {},
      listaInscritosAll: [],
      listaInscritos: [],
      nota: 0,
      progresso: false,

      valid: true,
      headers: [

        { text: 'Nome', value: 'nome_estudante' },
        { text: 'Nº Matricula', value: 'matricula' },
        { text: 'Disciplina', value: 'disciplina_descricao' },
        { text: 'Nota', value: 'nota' }
      ],
      ruleTextRequired: [
        value => !!value || 'campo obrigatório.',
        value => {
          const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{aA-zZ}]))$/
          return !pattern.test(value) || 'Invalido.'
        }
      ],

      editedIndex: -1,

      editedItem: {

        nota: 0

      }
    }
  },

  created () {
    this.InicializaTabela()
  },
  methods: {
    async save (obj) {
      this.progresso = true

      const valores =
          {
            idcadeira: this.$store.state.objcadeira.idcadeira_em_atraso,
            idturma: null,
            idpauta: null,
            nota: obj,
            autor: null,
            anodeixou: null,
            matricula: null,
            disciplina: null,
            turmad: null,
            fkpauta: null,
            fkturma: null,
            nome_estudante: null,
            disciplina_descricao: null,
            turma_descricao: this.null
          }
      try {
        let msg = await axios.post('/cadeiraAtrasoInsertOrUpdate', valores).then(res => res.data)
        // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 99000 })
        this.progresso = false
        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' Inscrição feita com sucesso'
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          }
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } catch (error) {}
      } catch (erro) {
        console.log('erro')
      } finally {
        this.dialog = false
      }
    },
    cancel () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    close () {
      console.log('Dialog closed')
    },
    backTodisciplinList () {
      this.$router.push('notasCadeira')
    },
    async InicializaTabela () {
      try {
        this.listaInscritosAll = await axios

          .get('/ListarInscritosCadeira')
          .then(res => res.data)
        this.listaInscritos = this.listaInscritosAll.filter(t => t.pkTurma == this.$store.state.objcadeira.pkTurma)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }

  }

}
</script>
